import { useMutation } from '@tanstack/react-query';
import { deleteGoogleIntegration } from 'admin/resources';

type DeleteUserIntegrationInput = {
	id: string;
};

const deleteUserIntegrationQueryFn = async ({ id }: DeleteUserIntegrationInput): Promise<void> => {
	await deleteGoogleIntegration.params({ id }).send();
};

export const useDeleteUserIntegration = () => {
	return useMutation<void, ApiV2ResponseError, DeleteUserIntegrationInput>({
		mutationFn: deleteUserIntegrationQueryFn,
	});
};
